export class MessageBus {
    constructor(messageBus) {
        this.messageBus = messageBus;
    }
    getSubscription(channel, handler, context) {
        this.messageBus.on(channel, handler, context);
        return () => this.messageBus.off(channel, handler, context);
    }
    emit(channel, ...params) {
        this.messageBus.emit(channel, ...params);
    }
}
//# sourceMappingURL=MessageBus.js.map